/**
 敏感词库
 */
import React, { Component } from 'react';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TableContent from './components/TableContent';
import model from '@/reducers/system/sensitiveword/model';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import EDModal from './modal/EDModal';
class SensitiveWord extends Component {

    static propTypes = {
        history: PropTypes.object, // 路由history对象
        match: PropTypes.object,
        getSensitiveWordList: PropTypes.func,
        sensitiveWordList: PropTypes.array,
        setBreadcrumbPaths: PropTypes.func,
    }

    static defaultProps = {
        sensitiveWordList: []
    }

    state = {
        renderModal: false,
        modalParams: {},
    }

    componentDidMount() {
        this.props.getSensitiveWordList();
    }

    //渲染弹框
    _renderModal = ({ state = false, id = '', type = '', libType = '', libText = '', title = '' }) => {
        this.setState({ renderModal: state, modalParams: { id, type, libType, libText, title } });
    }

    //关闭弹框
    _closeModal = (update) => {
        this.setState({ renderModal: false, modalParams: {} }, () => {
            update && this.props.getSensitiveWordList();
        });
    }

    render() {
        const { sensitiveWordList } = this.props;
        const { modalParams, renderModal } = this.state;

        return (
            <div className={styles.flexBoxContainer}>
                <TableContent
                    renderData={sensitiveWordList}
                    renderModal={this._renderModal}
                />
                {
                    renderModal &&
                    <EDModal
                        closeModal={this._closeModal}
                        modalParams={modalParams}
                    />
                }
            </div>
        );
    }
}
export default connect(state => ({
    sensitiveWordList: state.sensitiveword.sensitiveWordList,
}), {
    ...model.actions,
    setBreadcrumbPaths
})(SensitiveWord);